import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Color from 'constants/colors'
import {
  Wrapper, Notes, MyNotesContainer,
  ContainerLabel, OptionLabel, Options, 
  SpreadApart, MoreInfo
} from './styles'
import styled from 'styled-components'

const Inline = styled.div`
  display: inline;
`;

const Editable = styled.span`
  display: inline;
  font-family: ${props=>props.theme.fonts.h5};
  font-weight: bold;
  font-size: 14px;
  background-color: transparent;
  color: ${Color('purple')};
  outline: none;
  border: none;
  border-bottom: 2px solid black;
  -webkit-appearance: none;
  margin-left: 4px;
  margin-right: 4px;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const Editing = styled.span`
  -webkit-appearance: none;
  border: none;
  outline: none;
  &:focus {
    transition: background-color 200ms ease-in;
    background-color: rgba(0,0,0,0.025);
  }
`;



// NOTE: All real validation needs to happen on the backend as rendering
// dangrously user input is an extremely risky thing to do
class ContentEditable extends React.Component {
  shouldComponentUpdate(nextProps) {
    // TODO: sanitize
    let html = ReactDOM.findDOMNode(this).innerHTML;
    return nextProps.html !== html;
  }

  emitChange = (event) => {
    // TODO: sanitize
    const html = ReactDOM.findDOMNode(this).innerHTML;
    if (this.props.onChange && (html !== this.lastHtml)) {
      this.props.onChange({
        target: {
          value: html
        }
      });
    }
    this.lastHtml = html;
  }

  render() {
    return (
      <Editing
        onInput={this.emitChange}
        onBlur={this.emitChange}
        contentEditable
        dangerouslySetInnerHTML={{__html: this.props.html}}>
      </Editing>
    );
  }
}

class VotePrefEditor extends React.Component {
  constructor(props) {
    super(props);
    let { reason, shared, vote, voteText } = props.data.votePref.data;
    if (!voteText) voteText = props.data.placeholderText.first; //-- needs to match whats in VotePrefReader
    if (!reason) reason = props.data.placeholderText.second;
    this.state = {
      reason: reason,
      shared: shared,
      vote: vote,
      voteText: voteText,
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const {pageId, userId} = this.props.data;
    //-- if not logged in, take to login page
    //-- TODO, store everything so it redirects after people login
    if (!this.props.auth.loggedIn) {
      this.props.history.push('/user/login');
    } else {
      const voteText = this.state.voteText;
      const reason = this.state.reason;
      const { store } = this.context;
      const action = {
        type: "WRITE_VOTE_PREF_REQUESTED",
        payload: {
          pageId: pageId,
          userId: userId,
          data: {
            voteText: voteText,
            reason: reason,
          },
        }
      }
      store.dispatch(action);
    }
  }

  handleChange = (name, event) => {
    const valueToSet = event.target.value ? event.target.value : null;
    this.setState({
      [name]: valueToSet
    });
  };

  render() {
    /* eslint-disable array-callback-return */
    const options = this.props.options.map( (option,i) => {
      switch(option) {
        case "login":
          return (
            <OptionLabel
              key={"login"}
              onClick={this.handleSubmit}>
              Login to save this
            </OptionLabel>
          );
        case "save":
          return (
            <OptionLabel
              key={"save"}
              onClick={this.handleSubmit}>
              Save
            </OptionLabel>
          );
        case "cancel":
          return (
            <OptionLabel
              key={"cancel"}
              onClick={this.props.data.onToggleEdit}>
              Cancel
            </OptionLabel>
          );
        case "edit":
          return (
            <OptionLabel
              key={"edit"}
              onClick={this.props.data.onToggleEdit}>
              Edit
            </OptionLabel>
          );
        default:
          break;
      }
      return;
    });

    return(
      <Wrapper>
        <ContainerLabel>
          <span role="img" aria-label="notebook">📓&nbsp;</span> 
          {this.props.title}
        </ContainerLabel>
        <MyNotesContainer>
          <Notes>
          <Inline>
            I feel
            <Editable>
              <ContentEditable
                html={this.state.voteText}
                onChange={this.handleChange.bind(this, "voteText")}
              />
            </Editable>
            about this proposition and I
            <Editable>
              <ContentEditable
                html={this.state.reason}
                onChange={this.handleChange.bind(this, "reason")}
              />
            </Editable>.
          </Inline>
          </Notes>
        </MyNotesContainer>
        <SpreadApart>
          <MoreInfo to="/election/personalized-guide">Learn more bout this</MoreInfo>
          <Options>
            {options}
          </Options>
        </SpreadApart>
      </Wrapper>
    )
  }
}

VotePrefEditor.contextTypes = {
  store: PropTypes.object
};

VotePrefEditor.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    votePref: PropTypes.shape({
      data: PropTypes.object.isRequired,
    }),
    pageId: PropTypes.string.isRequired,
    userId: PropTypes.string, // would like to make this required
    onToggleEdit: PropTypes.func.isRequired,
  }).isRequired,
  options: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  const user = state.user.data || {};
  const { auth } = state;
  return { user, auth };
}

export default connect(mapStateToProps, {})(withRouter(VotePrefEditor));




// WEBPACK FOOTER //
// ./src/components/interactive/votePref/VotePrefEditor.js